import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { IPriceListViewModel, IContractViewModel, ISelectedServiceProductViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, TarificationIdEnum } from "../../../../../../Scripts/inpulse/CommonEnums";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { CommonFormatUtils } from "../../../../../../Scripts/inpulse/FormatUtils";
import { PriceListUtils } from "../../../../../../Scripts/inpulse/PriceListUtils";
library.add(faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)

@Component({

})

export default class PriceListDisplay extends Vue {
    @Prop()
    priceList: IPriceListViewModel;
    @Prop({ default: true })
    actions: boolean;
    @Prop()
    isSelected: boolean;
    @Prop()
    showVat: boolean;
    @Emit()
    selected(priceList: IPriceListViewModel) { }

    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;
    get tarification(): TarificationIdEnum { return this.$store.state.contract.TarificationId; }
    get energy1(): number { return this.$store.state.contract.Energy1; }
    get energy2(): number { return this.$store.state.contract.Energy2; }
    get selectedServiceProducts(): string[] { return this.$store.state.selectedServiceProducts; }
    get contract(): IContractViewModel { return this.$store.state.contract; }

    constructor() {
        super();
    }

    formatDuration(contract: IContractViewModel, priceList: IPriceListViewModel) {
        return CommonFormatUtils.formatDuration(contract, priceList, this.$i18n.locale);
    }

    showPriceEstimate(priceList: IPriceListViewModel) {
        return PriceListUtils.showPriceEstimate(priceList);
    }

    getFixedPrice(price: number, digits: number) {
        return PriceListUtils.getFixedPrice(price, digits);
    }

    priceEstimate(priceLists: IPriceListViewModel) {
        return this.calculatePriceEstimate(priceLists).toFixed(2);
    }

    calculatePriceEstimate(priceList: IPriceListViewModel) {
        let priceEstimate = PriceListUtils.calculatePriceEstimate(priceList, this.showVat, this.tarification, this.energy1, this.energy2); //includes mandatory service products
        //Add costs of selected optional service products
        let extraCost = 0.0;
        console.log("pricelist: ", priceList)
        if (priceList.PriceListServiceProducts != null) {
            for (let ind = 0; ind < priceList.PriceListServiceProducts.length; ind++) {
                if (priceList.PriceListServiceProducts[ind].PriceListServiceProductType === 1) {
                    const sp = priceList.PriceListServiceProducts[ind];
                    const key = priceList.Id.toFixed() + ";" + sp.ServicePriceList.ExternalPriceListId;
                    const index = this.selectedServiceProducts.indexOf(key, 0);
                    if (index > -1) { //service product was found among the selected ones
                        extraCost += PriceListUtils.calculateServiceProductPrice(sp.ServicePriceList.ProductComponents[0], this.showVat, this.tarification, this.energy1, this.energy2);
                    }
                }
            }
        }
        priceEstimate = priceEstimate + extraCost;
        return priceEstimate;
    }

    isServiceProductSelected(priceListId: number, serviceProductExternalPriceListId: string): boolean {
        console.log("this.selectedServiceProducts.length: " + this.selectedServiceProducts.length);
        const index = this.selectedServiceProducts.indexOf(priceListId.toFixed() + ";" + serviceProductExternalPriceListId, 0);
        if (index > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    showEnergyType(): boolean {
        if (this.contract.ExtraFeatures && this.contract.ExtraFeatures.length > 0) {
            //if (this.contract.Brand && (this.contract.Brand.toLowerCase() == "priima" || this.contract.Brand.toLowerCase() == "priimaplus")) {
            if (this.contract.ExtraFeatures.find(c => c.Name == 'Tuulivoima' || c.Name == 'Vesivoima')) {
                    return true;
                }
            //}
        }
        return false
    }

    getEnergyType(): string {
        let energyType = this.contract.ExtraFeatures.find(c => c.Name == 'Tuulivoima' || c.Name == 'Vesivoima');
        let isCompany = this.contract.CustomerType == CustomerTypeEnum.COMPANY;
        let price: string = isCompany ? energyType.Price.toFixed(4) : energyType.Price.toFixed(2)
        price = price.replace(".", ",");
        return energyType.Name + " + " + price + " snt/kWh";
    }
}
